import { render, staticRenderFns } from "./CookieDialog.vue?vue&type=template&id=204d8466&"
import script from "./CookieDialog.vue?vue&type=script&lang=js&"
export * from "./CookieDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports